"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ratio = require("../../services/ratio/ratio.service");

var _default = _propTypes.default.oneOf(_ratio.RATIO_KEYS);

exports.default = _default;